export default __webpack_public_path__ + "static/media/registered-mark.9da3ce33.svg";